import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FeatherModule } from 'angular-feather';
import { AsyncPipe } from '@angular/common';

import { OfflineInterceptor } from '../../maintenance/offline-interceptor';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.scss'],
  imports: [FeatherModule, AsyncPipe],
})
export class MaintenancePageComponent {
  isOffline$ = OfflineInterceptor.isOffline$;

  close() {
    OfflineInterceptor.isOffline$.next(false);
  }
}
